import * as React from 'react';
import moment from 'moment';

interface Props {
  momentObject?: any;
  dateToParse?: string;
  key: string;
}

/**
 * This renders text like "a few seconds ago" but refreshes
 * every 30 seconds so it doesn't get stuck at "a few seconds ago"
 * 
 * Make sure to supply a key prop so this component re-initializes
 * if the date prop changes
 */
export default class FromNowDateText extends React.Component<Props> {
  momentDateObject = null;
  lastUpdatedInterval = null;

  constructor(props) {
    super(props);

    if (this.props.momentObject) {
      this.momentDateObject = this.props.momentObject;
    } else if (this.props.dateToParse) {
      this.momentDateObject = moment(this.props.dateToParse);
    } else {
      console.error('No date supplied to relative date component');
    }
  }

  componentDidMount() {
    this.lastUpdatedInterval = window.setInterval(() => {
      this.forceUpdate();
    }, 30000);
  }

  componentWillUnmount() {
    if (!window) {
      return;
    }

    window.clearInterval(this.lastUpdatedInterval);
  }

  render() {
    return this.momentDateObject.fromNow();
  }
}
